import { createContext, useContext, useMemo, useState, useEffect } from 'react';
import { geocodingTypeOptions, coordSystemOptions } from 'constants/geocoder/options';

const GeoCodingContext = createContext(null);

export function GeoCodingProvider({ children }) {
    const [geocodingType, setGeocodingType] = useState(geocodingTypeOptions[0]);
    const [coordSystem, setCoordSystem] = useState(coordSystemOptions[0]);

    const [file, setFile] = useState(null);
    const [isShapefile, setIsShapefile] = useState(false);
    const [dataEpsg, setDataEpsg] = useState('EPSG:3857');
    const [swapXY, setSwapXY] = useState(false);

    // Grid Data (useFileReader의 rows/columns와 useUploadWorkflow의 localGrid 대체)
    const [gridRows, setGridRows] = useState([]); 
    const [gridColumns, setGridColumns] = useState([]);

    // Result/Preview Data
    const [previewGeoJSON, setPreviewGeoJSON] = useState(null);
    const [resultGeoJSON, setResultGeoJSON] = useState(null);
    const [resultBlob, setResultBlob] = useState(null);
    const [resultMeta, setResultMeta] = useState(null);
    const [resultName, setResultName] = useState('geocode_result');

    // Status/Fields
    const [lastStatus, setLastStatus] = useState('');
    const [fileReadError, setFileReadError] = useState(null);
    const [shapeAddrOpts, setShapeAddrOpts] = useState([]);
    const [shapeAddrField, setShapeAddrField] = useState(null);
    const [sheetAddrOpts, setSheetAddrOpts] = useState([]); 
    const [sheetAddrField, setSheetAddrField] = useState(null); 
    const [xyFieldOptions, setXyFieldOptions] = useState([]);
    const [xField, setXField] = useState(null);
    const [yField, setYField] = useState(null);
    const [isFileDeletedAfterUpload, setIsFileDeletedAfterUpload] = useState(false);

    const value = useMemo(
        () => ({
            geocodingType,
            setGeocodingType,
            coordSystem,
            setCoordSystem,

            // 공유 상태 (File/Data)
            file, setFile,
            isShapefile, setIsShapefile,
            dataEpsg, setDataEpsg,
            swapXY, setSwapXY,
            gridRows, setGridRows, 
            gridColumns, setGridColumns,
            previewGeoJSON, setPreviewGeoJSON,
            resultGeoJSON, setResultGeoJSON,
            resultBlob, setResultBlob,
            resultMeta, setResultMeta,
            resultName, setResultName,
            lastStatus, setLastStatus,
            fileReadError, setFileReadError,
            isFileDeletedAfterUpload, setIsFileDeletedAfterUpload,

            // 공유 상태 (Fields)
            shapeAddrOpts, setShapeAddrOpts,
            shapeAddrField, setShapeAddrField,
            sheetAddrOpts, setSheetAddrOpts,
            sheetAddrField, setSheetAddrField,
            xyFieldOptions, setXyFieldOptions,
            xField, setXField,
            yField, setYField,

        }),
        // [geocodingType, coordSystem]
        [
            geocodingType, coordSystem, file, isShapefile, dataEpsg, swapXY, 
            gridRows, gridColumns, previewGeoJSON, resultGeoJSON, resultBlob, 
            resultMeta, resultName, lastStatus, fileReadError, shapeAddrOpts, shapeAddrField, 
            sheetAddrOpts, sheetAddrField, xyFieldOptions, xField, yField, 
        ]
    );

    return <GeoCodingContext.Provider value={value}>{children}</GeoCodingContext.Provider>;
}

export function useGeoCodingContext() {
    const ctx = useContext(GeoCodingContext);
    if (!ctx) {
        throw new Error('useGeoCodingContext must be used within GeoCodingProvider');
    }
    return ctx;
}
